<div
  class="trancheViewGroup"
  *ngIf="(showCombineButton | async)"
  [cupcakePopover]="popover"
  data-automation-e2e-selector="trancheCombineContainer"
>
  <span class="trancheViewArrow" [textContent]="progressBarIcon"></span>
  <button
    [ngClass]="[
      'fa',
      !!tranchesCombined ? 'fa-unlink' : 'fa-link',
      'trancheViewToggle'
    ]"
    (click)="trancheViewToggle()"
    data-automation-e2e-selector="trancheCombineButton"
  ></button>
</div>
